module.exports = __webpack_public_path__ + "img/compass-02.654f88eb.svg";